import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import {
    fetchAddProveedor,
    fetchEditProveedor,
    fetchGetProveedorList,
    setFilters,
    returnFetchDeleteProveedor,
    setLogError,
    setPage,
    setItemsPerPage
} from "../../reducers/proveedorSlice";

import {
    ProveedorColumnList,
    ProveedorFilterValidationSchema,
    ProveedorValidationSchema
} from "./ProveedorConstants";
import GenericModule from "../../components/GenericModule";


function ProveedorList(props) {

    const moduleData = useSelector((state) => state.proveedor);
    const logguedUserData = useSelector(state => state.common.logguedUserData);

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const emptyNew = {};;

    useEffect(() => {
        dispatch(fetchGetProveedorList({ page: 0, pageCount: 0, rowsPerPage: moduleData.itemsPerPage }));
    }, []);

    const refreshData = (filters) => {
        dispatch(fetchGetProveedorList({ ...filters }));
    }

    const editData = (data) => {
        return Promise.all([
            dispatch(fetchEditProveedor(data)),
        ]);
    }

    const insertData = (data) => {
        return Promise.all([
            dispatch(fetchAddProveedor(data)),
        ]);
    }

    const updateFilters = (filters) => {
        dispatch(setFilters(filters));
    }

    const deleteData = async (id) => {
        const response = await returnFetchDeleteProveedor(id);
        return response;
    }

    const clearLogError = () => {
        dispatch(setLogError(null));
    }

    const handleSetPage = (page) => {
        dispatch(setPage(page));
    }

    const handleSetItemsPerPage = (ipp) => {
        dispatch(setItemsPerPage(ipp));
    }

    return (
        <GenericModule
            module={"proveedor"}
            validationSchema={ProveedorValidationSchema(t)}
            filterValidationSchema={ProveedorFilterValidationSchema(t)}
            columnList={ProveedorColumnList(logguedUserData.isAdmin)}
            emptyNew={emptyNew}
            setFilters={updateFilters}
            dataList={moduleData.proveedorList}
            moduleData={moduleData}
            refreshData={refreshData}
            editData={editData}
            insertData={insertData}
            deleteData={deleteData}
            clearLogError={clearLogError}
            setPage={handleSetPage}
            setItemsPerPage={handleSetItemsPerPage}
        />
    );
}

export default ProveedorList;
